var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox user-points-page" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "page-title" }, [_vm._v("用户积分管理")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-wrap" },
            [
              _c("el-input", {
                staticClass: "keyword-input",
                attrs: {
                  placeholder: "请输入用户id/姓名/手机号",
                  size: "small",
                  clearable: "",
                  "prefix-icon": "el-icon-search",
                },
                model: {
                  value: _vm.query.keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "keyword", $$v)
                  },
                  expression: "query.keyword",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("来源小程序:")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-200",
                      attrs: {
                        filterable: "",
                        remote: "",
                        clearable: "",
                        placeholder: "全部",
                        "remote-method": _vm.searchMiniAppOptions,
                        loading: _vm.miniAppLoading,
                        size: "small",
                      },
                      model: {
                        value: _vm.query.customerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "customerId", $$v)
                        },
                        expression: "query.customerId",
                      },
                    },
                    _vm._l(_vm.miniAppOptions, function (item) {
                      return _c("el-option", {
                        key: item.customerId,
                        attrs: { label: item.appName, value: item.customerId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleQuery },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small", plain: "" },
                  on: { click: _vm.handleReset },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "data-table",
              attrs: {
                data: _vm.displayTableData,
                size: "small",
                border: "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "60",
                  align: "center",
                  index: _vm.mainTableIndexMethod,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "姓名", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "availablePoints",
                  label: "可用积分",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalEarned",
                  label: "累积获取积分",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalConsumed",
                  label: "累积消耗积分",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalRefundIntegral",
                  label: "累积退还积分",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalRecycleIntegral",
                  label: "累积回收积分",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "lastChangeTime",
                  label: "最新变动时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "来源小程序",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:shopintegral:userIntegral:detailPage",
                                ],
                                expression:
                                  "['admin:shopintegral:userIntegral:detailPage']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetailDrawer(scope.row)
                              },
                            },
                          },
                          [_vm._v("积分明细")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageData.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageData.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.listTotal,
                },
                on: {
                  "size-change": _vm.handleMainSizeChange,
                  "current-change": _vm.handleMainPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "积分明细",
            visible: _vm.detailVisible,
            direction: "rtl",
            size: "960px",
            "wrapper-closable": true,
            "custom-class": "points-detail-drawer",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
            close: _vm.onDetailDrawerClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "drawer-body" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.detailStatLoading,
                      expression: "detailStatLoading",
                    },
                  ],
                  staticClass: "detail-summary detail-summary-loading",
                },
                [
                  _c("div", { staticClass: "summary-row" }, [
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "sum-label" }, [
                        _vm._v("姓名："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sum-value" }, [
                        _vm._v(_vm._s(_vm.detailUser.name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "sum-label" }, [
                        _vm._v("手机号："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sum-value" }, [
                        _vm._v(_vm._s(_vm.detailUser.phone)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "sum-label" }, [
                        _vm._v("来源小程序："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sum-value" }, [
                        _vm._v(_vm._s(_vm.detailUser.customerName)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-row" }, [
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "sum-label" }, [
                        _vm._v("可用积分："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sum-value" }, [
                        _vm._v(_vm._s(_vm.detailUser.availablePoints)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "sum-label" }, [
                        _vm._v("待入账积分："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sum-value" }, [
                        _vm._v(_vm._s(_vm.detailUser.pendingIntegral)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "sum-label" }, [
                        _vm._v("累积获取积分："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sum-value" }, [
                        _vm._v(_vm._s(_vm.detailUser.totalEarned)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "sum-label" }, [
                        _vm._v("累积消耗积分："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sum-value" }, [
                        _vm._v(_vm._s(_vm.detailUser.totalConsumed)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "sum-label" }, [
                        _vm._v("累积退回积分："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sum-value" }, [
                        _vm._v(_vm._s(_vm.detailUser.totalRefundIntegral)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "sum-label" }, [
                        _vm._v("累积回收积分："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sum-value" }, [
                        _vm._v(_vm._s(_vm.detailUser.totalRecycleIntegral)),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "drawer-toolbar" },
                [
                  _c("el-input", {
                    staticClass: "drawer-search-input",
                    attrs: {
                      placeholder: "请输入积分流水号",
                      size: "small",
                      clearable: "",
                      "prefix-icon": "el-icon-search",
                    },
                    model: {
                      value: _vm.detailQuery.serialKeyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailQuery, "serialKeyword", $$v)
                      },
                      expression: "detailQuery.serialKeyword",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "drawer-date-wrap" },
                    [
                      _c("span", { staticClass: "drawer-date-label" }, [
                        _vm._v("变动时间范围："),
                      ]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticClass: "drawer-date-picker",
                        attrs: {
                          type: "datetimerange",
                          size: "small",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "default-time": _vm.DETAIL_DATE_RANGE_DEFAULT_TIME,
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                        },
                        on: { input: _vm.onDetailDateRangeInput },
                        model: {
                          value: _vm.detailQuery.dateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.detailQuery, "dateRange", $$v)
                          },
                          expression: "detailQuery.dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "drawer-change-type-wrap" },
                    [
                      _c("span", { staticClass: "drawer-date-label" }, [
                        _vm._v("积分变动类型："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticClass: "drawer-change-type-select",
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "全部",
                          },
                          model: {
                            value: _vm.detailQuery.changeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.detailQuery, "changeType", $$v)
                            },
                            expression: "detailQuery.changeType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 1, label: "积分获取" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 2, label: "积分消耗" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 4, label: "积分退还" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 5, label: "积分回收" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:shopintegral:userIntegral:detailPage"],
                          expression:
                            "['admin:shopintegral:userIntegral:detailPage']",
                        },
                      ],
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleDetailQuery },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.detailDetailLoading,
                      expression: "detailDetailLoading",
                    },
                  ],
                  staticClass: "detail-table",
                  attrs: {
                    data: _vm.detailTableDisplay,
                    size: "small",
                    border: "",
                    "header-cell-style": {
                      fontWeight: "bold",
                      background: "#fafafa",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "serialNo",
                      label: "积分流水号",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "changeTypeText",
                      label: "积分变动类型",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "changeValue",
                      label: "积分变动值",
                      "min-width": "100",
                      align: "right",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "balanceAfter",
                      label: "剩余积分",
                      "min-width": "90",
                      align: "right",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remark",
                      label: "变动说明",
                      "min-width": "220",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "changeTime",
                      label: "变动时间",
                      "min-width": "160",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "drawer-pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.detailPage.page,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.detailPage.limit,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.detailListTotal,
                    },
                    on: {
                      "size-change": _vm.handleDetailSizeChange,
                      "current-change": _vm.handleDetailPageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }